import { BasicEntity } from "../../core/models/basic-entity";

export class DeliveryTime extends BasicEntity {
  
    constructor(entity?: Partial<DeliveryTime>) {
        super();
        Object.assign(this, entity);
    }
}
